import _slicedToArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
export var Suripanta = function Suripanta(_ref) {
  var children = _ref.children,
      parent = _ref.parent,
      type = _ref.type,
      location = _ref.location,
      attributes = _ref.attributes,
      lazyLoad = _ref.lazyLoad;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  useEffect(function () {
    window.addEventListener('load', function () {
      setLoaded(true);
    });
    return window.addEventListener('load', function () {
      setLoaded(false);
    });
  }, []);
  if (lazyLoad && !loaded) return null;
  var element = document.querySelector(parent);

  if (!element) {
    return null;
  }

  var s = document.createElement(type);
  if (children) s.innerHTML = children;
  if (attributes) attributes.forEach(function (attribute) {
    s.setAttribute(attribute.name, attribute.value);
  });

  if (location === 'start') {
    element.prepend(s);
  } else {
    element.appendChild(s);
  }

  return null;
};